import React from 'react'
import { FaChartPie } from 'react-icons/fa'
import ClassDistributionCard from '../../../ClassDistributionCard'
import { StepCard, StepHeader, StepContent } from '../ModelPerformanceCard.styles'

interface DistributionCardProps {
  gradients: {
    distribution: string
  }
  title: string
  dataSources: string[]
  datasetId?: string
  isLoading: boolean
}

const DistributionCard: React.FC<DistributionCardProps> = ({
  gradients,
  title,
  dataSources,
  datasetId,
  isLoading,
}) => {
  return (
    <StepCard>
      <StepHeader $gradient={gradients.distribution}>
        {title} Data Distribution
        <FaChartPie />
      </StepHeader>
      <StepContent>
        {isLoading ? (
          <div>Loading...</div>
        ) : (
          <ClassDistributionCard
            useSources={dataSources}
            title=""
            height="275px"
            datasetId={datasetId}
          />
        )}
      </StepContent>
    </StepCard>
  )
}

export default DistributionCard
